import {ProcessFlowRunProcessStep} from "~/models/processFlows/steps/processFlowRunProcessStep";
import {IVariableLink} from "~/interfaces/processFlowInterfaces";
import Guid from "~/helpers/guid";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import ProcessFlowBuilderModel from "~/models/tracked/processFlowBuilderModel";

export class IOVariableLink extends ProcessFlowBuilderModel implements IVariableLink {
  parent: ProcessFlowRunProcessStep;
  variable_client_id: string;
  linked_variable_client_id: string;
  is_input: boolean;
  _nameInParent: string = 'io_variable_links';

  constructor(parent, json) {
    super(parent);
    this.defineProperty("client_id", json.client_id || Guid.create());
    this.defineProperty('variable_client_id', json.variable_client_id)
    this.defineProperty('linked_variable_client_id', json.linked_variable_client_id)
    this.defineProperty('is_input', json.is_input)
    this.parent = parent;
    this.rootModel = this.parent.processFlow;
  }

  get rootName(): string {
    return 'io_variable_links'
  }

  static repo: IRepo<IOVariableLink> = new Repo<IOVariableLink>('variableLinks', IOVariableLink, {});
}